import { Component, OnInit, ViewChild } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
import {Router} from '@angular/router';
import { ClienteLogin } from '../../../views/login/cliente_login';
import { UsuarioLoginEntity, UsuarioRespuestaEntity } from "../../../views/login/usuario_login_entity";
import { SessionStorageService } from "ngx-webstorage";
import { ModalComponent } from '../../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal';
import { UtilService } from '../utils/util.service';
import { ShowHideInput, ShowHideInput2 } from '../../../views/register/show-hide-input.directive';
import { ShowHideInputCam, ShowHideInputCam2, ShowHideInputCam3 } from './topnavbar.showhide';
import { LoginService } from '../../../views/login/login.service';


declare var jQuery:any;
const swal = require("sweetalert2");

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html'
})
export class TopnavbarComponent implements OnInit {
    @ViewChild('cambiarPassword')
    modalPass: ModalComponent;
    showLoaderModalPass: string = "";

    show = false;
    show2 = false;
    show3 = false;
    
    usuarioLogin: UsuarioLoginEntity;
    usuario: ClienteLogin;
    NombreUsuario: string;
    usuCambio: UsuarioRespuestaEntity = new UsuarioRespuestaEntity();

    @ViewChild(ShowHideInputCam)
    input: ShowHideInputCam;

    @ViewChild(ShowHideInputCam2)
    input2: ShowHideInputCam2;

    @ViewChild(ShowHideInputCam3)
    input3: ShowHideInputCam3;

    constructor(private loginService: LoginService,private router: Router, private sessionStorageService: SessionStorageService, public utilService:UtilService){
    }

    toggleNavigation(): void {
        jQuery("body").toggleClass("mini-navbar");
        smoothlyMenu();
    }

    cambiaContrasena() {
        this.usuCambio.Respuesta = "";
    }

    toggleShow(e: any, campo: number) {
        if (campo == 1) {
            this.show = !this.show;

            if (this.show) {
                this.input.changeType("text");
            }
            else {
                this.input.changeType("password");
            }
        }
        else if (campo == 2) {
            this.show2 = !this.show2;

            if (this.show2) {
                this.input2.changeType("text");
            }
            else {
                this.input2.changeType("password");
            }
        }
        else {
            this.show3 = !this.show3;

            if (this.show3) {
                this.input3.changeType("text");
            }
            else {
                this.input3.changeType("password");
            }
        }
    }

    ngOnInit():void{       
        this.usuarioLogin = jQuery.parseJSON(this.sessionStorageService.retrieve("usuarioLogin"));
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
        this.usuCambio.Contrasena="";
        this.usuCambio.OtraContrasena="";
        this.usuCambio.Respuesta = "";
        if (this.usuario == null){
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login",bandera]);
        }
        else{
            try{
                this.NombreUsuario = jQuery.parseJSON(this.sessionStorageService.retrieve("nombreuser"));
            }catch(e){
                this.NombreUsuario = this.sessionStorageService.retrieve("nombreuser");
            }
            
            this.sessionStorageService.observe("nombreuser").subscribe(a=>{
                try{
                    this.NombreUsuario = jQuery.parseJSON(a);
                }catch(e){
                    this.NombreUsuario = a;
                }
            });
            this.usuCambio.CodigoUsuario = this.usuario.CodigoUsuario;
        }
    }

    cambiarPass(){
        this.modalPass.open();
    }

    cambioPass(){
        this.showLoaderModalPass = "sk-loading";
        this.loginService.CambioPasswordDentro(this.usuCambio).subscribe(
            result => {
                this.modalPass.close();
                this.showLoaderModalPass = "";
                if (result.Error == 0) {
                    swal({
                        title: 'Cambio contraseña',
                        text: "El cambio de contraseña se ha realizado correctamente",
                        type: 'success'
                    });
                }
                if(result.Error != 0){
                    swal({
                        title: 'Cambio contraseña',
                        text: result.Mensaje,
                        type: 'error'
                    }); 
                }
            },
            error => {
                this.showLoaderModalPass = "";
                this.modalPass.close();
                swal({
                    title: 'Cambio contraseña',
                    text: "Ha ocurrido un error al momento del cambio de contraseña, lamentamos el inconveniente",
                    type: 'error'
                });
            }
        );
        this.usuCambio.Contrasena="";
        this.usuCambio.OtraContrasena="";
        this.usuCambio.Respuesta = "";
    }

    closeModalPass(){
        this.usuCambio = new UsuarioRespuestaEntity();
        this.modalPass.close();
    }

}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/topnavbar/topnavbar.component.ts